import { AdyenSession, PaymentMethod, PaymentToken, RidangoReduxAction } from '@ridango/core';
import { CartStatus } from '../../../lib/purchase/purchase.model';

import { tassign } from 'tassign';

import { PaymentMethodsActions } from './payment-methods.actions';

export interface PaymentMethodsState {
    allIds: any[];
    all: PaymentMethod[];
    methods: any;
    selected: PaymentMethod;
    loading: boolean;
    accountMethods: any;
    selectedAccountMethod: PaymentToken;
    error: any;
    adyenSession: AdyenSession;
    cartStatus: CartStatus;
    cartRedirectUrl: string;
}
export const PAYMENT_METHODS_INITIAL_STATE: PaymentMethodsState = {
    allIds: [],
    all: [],
    methods: {},
    selected: null,
    loading: false,
    accountMethods: {},
    selectedAccountMethod: null,
    error: null,
    cartStatus: null,
    cartRedirectUrl: null,
    adyenSession: {
        session_id: null,
        session_data: null,
        client_key: null,
        sessionLoading: false,
        checkedPaymentStatus: null
    }
};

export const PAYMENT_METHODS_STATE_KEY = 'payment';

export function paymentMethodsReducer(
    lastState: PaymentMethodsState = PAYMENT_METHODS_INITIAL_STATE,
    action: RidangoReduxAction
): PaymentMethodsState {
    switch (action.type) {
        case PaymentMethodsActions.FETCH_START:
            return tassign(lastState, { loading: true });
        case PaymentMethodsActions.FETCH_FAILED:
            return tassign(lastState, { loading: false });
        case PaymentMethodsActions.FETCH_SUCCESS:
            return tassign(lastState, {
                allIds: action.payload.allIds,
                methods: action.payload.methods,
                all: action.payload.all,
                loading: false
            });
        case PaymentMethodsActions.SET_SELECTED:
            return tassign(lastState, { selected: action.payload });
        case PaymentMethodsActions.CLEAR:
            return tassign(lastState, PAYMENT_METHODS_INITIAL_STATE);
        case PaymentMethodsActions.SET_SELECTED_METHOD_PIN:
            return tassign(lastState, { selected: { ...lastState.selected, ...action.payload } });
        case PaymentMethodsActions.SET_ALL_ACCOUNT_METHODS:
            return tassign(lastState, { accountMethods: action.payload });
        case PaymentMethodsActions.SET_SELECTED_ACCOUNT_METHOD:
            return tassign(lastState, { selectedAccountMethod: action.payload });
        case PaymentMethodsActions.FETCH_ADYEN_SESSION:
            return tassign(lastState, {
                error: null,
                adyenSession: {
                    session_id: action.payload.id,
                    session_data: action.payload.sessionData,
                    client_key: action.payload.clientKey,
                    sessionLoading: true,
                    checkedPaymentStatus: null
                }
            });
        case PaymentMethodsActions.FETCH_ADYEN_SESSION_SUCCESS:
            return tassign(lastState, {
                adyenSession: {
                    session_id: action.payload.id,
                    session_data: action.payload.sessionData,
                    client_key: action.payload.clientKey,
                    sessionLoading: false
                }
            });
        case PaymentMethodsActions.FETCH_ADYEN_SESSION_FAILED:
            console.error('FETCH_ADYEN_SESSION_FAILED', action.payload);
            return tassign(lastState, {
                error: action.payload,
                adyenSession: {
                    session_id: null,
                    session_data: null,
                    client_key: null,
                    sessionLoading: false
                }
            });
        case PaymentMethodsActions.FETCH_ADYEN_PAYMENT_STATUS:
            return tassign(lastState, {
                error: null,
                adyenSession: {
                    ...lastState.adyenSession,
                    checkedPaymentStatus: null
                }
            });
        case PaymentMethodsActions.FETCH_ADYEN_PAYMENT_STATUS_SUCCESS:
            return tassign(lastState, {
                adyenSession: {
                    ...lastState.adyenSession,
                    checkedPaymentStatus: action.payload
                }
            });
        case PaymentMethodsActions.FETCH_ADYEN_PAYMENT_STATUS_FAILED:
            console.error('FETCH_ADYEN_PAYMENT_STATUS_FAILED', action.payload);
            return tassign(lastState, {
                error: action.payload,
                adyenSession: {
                    ...lastState.adyenSession
                }
            });

        case PaymentMethodsActions.SET_CART_STATUS:
            return tassign(lastState, { cartStatus: action.payload });

        case PaymentMethodsActions.SET_CART_REDIRECT_URL:
            return tassign(lastState, { cartRedirectUrl: action.payload });
    }
    return lastState;
}

export interface PaymentMethodsPartialStoreState {
    [PAYMENT_METHODS_STATE_KEY]: PaymentMethodsState;
}
